<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="false">
      <Header />
      <div class="br-pagebody pd-x-20 pd-sm-x-30">
        <div class="row">
          <div class="col-12">
            <div class="card card-body pd-25 bg-white">
              <div class="form-wrap">
                <h2>{{ $t("product.基础信息") }}</h2>
           
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.SKU编号：")
                    }}<span class="tx-danger">*</span>
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      :disabled="oldStatus != 3 && id"
                      v-model.trim="sku"
                    />
                  </div>
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.SPU编号：") }}
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="spu"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    />
                  </div>
                </div>

                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品名称：")
                    }}<span class="tx-danger">*</span>
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="name"
                    />
                  </div>
                   <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.英文名：")
                    }}
                  </label>
                   <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.trim="name_en"
                    />
                  </div>
                </div>

                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.成本价：") }}<span>￥</span>
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-PRICE
                      v-model.number="price"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    />
                  </div>
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.销售价：") }}
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-PRICE
                      v-model.number="salePrice"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    />
                  </div>
                </div>

                <div class="form-row mg-b-15">
                  <label
                    v-if="!(status == 3 && id)"
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.状态：") }}<span class="tx-danger">*</span>
                  </label>
                  <div v-if="!(status == 3 && id)" class="col-4">
                    <select
                      class="form-control form-control-sm"
                      :disabled="
                        (status == 3 && id) || userinfo.notSupplyChangeInfo == 1
                      "
                      v-model="status"
                    >
                      <option value="">{{ $t("product.请选择") }}</option>
                      <option value="1">{{ $t("product.正常销售") }}</option>
                      <option value="2">{{ $t("product.停止销售") }}</option>
                      <option v-if="!id || status == 3" value="3">
                        {{ $t("product.自动创建") }}
                      </option>
                    </select>
                  </div>
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品重量：") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="weight"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    />
                    <span class="pd-x-5">{{ $t("product.克") }}</span>
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.库存数量：") }}
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="totalInventory"
                    />
                  </div>
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.原厂SKU：") }}
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="factorySku"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    />
                  </div>
                </div>
                     <div class="form-row mg-b-15">
                   <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品属性：") }}<span class="tx-danger">*</span>
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="propertyValue"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    />
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品分类：") }}<span class="tx-danger">*</span>
                  </label>
                  <div class="col-9 d-flex align-items-center">
                    <select
                      class="form-control form-control-sm mg-r-15"
                      v-model="category"
                      @change="selectCategory"
                      :disabled="userinfo.notSupplyChangeInfo == 1"
                    >
                      <option value="">{{ $t("product.请选择") }}</option>
                      <option
                        v-for="ca in categorys"
                        :key="ca.categoryId1688"
                        :value="ca.categoryId1688"
                      >
                        {{ ca.name }}
                      </option>
                    </select>
                    <select
                      class="form-control form-control-sm mg-r-15"
                      v-model="category1"
                      :disabled="
                        categorys1.length < 1 ||
                        userinfo.notSupplyChangeInfo == 1
                      "
                      @change="selectCategory1"
                    >
                      <option value="">{{ $t("product.请选择") }}</option>
                      <option
                        v-for="ca in categorys1"
                        :key="ca.categoryId1688"
                        :value="ca.categoryId1688"
                      >
                        {{ ca.name }}
                      </option>
                    </select>
                    <select
                      class="form-control form-control-sm"
                      v-model="category2"
                      :disabled="
                        categorys2.length < 1 ||
                        userinfo.notSupplyChangeInfo == 1
                      "
                    >
                      <option value="">{{ $t("product.请选择") }}</option>
                      <option
                        v-for="ca in categorys2"
                        :key="ca.categoryId1688"
                        :value="ca.categoryId1688"
                      >
                        {{ ca.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.国家：") }}
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="country"
                    />
                  </div>
                 
                    <label
                    v-if="TMSFlag"
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.货盘展示状态：") }}
                  </label>
                  <div class="col-4 mg-b-0" style="display:flex;margin-top: 5px;" v-if="TMSFlag">
                    <div class="mg-b-15">
                      <label class="ckbox mg-b-0 mg-r-25">
                        <input
                          type="checkbox"
                          :value="'1'"
                          disabled
                          :checked="TMSFlag == '1'"
                          
                        />
                        <span>{{ $t("product.正常展示") }}</span>
                      </label>
                    </div>
                    <div class=" mg-b-15">
                      <label class="ckbox mg-b-0 mg-r-25">
                        <input
                          type="checkbox"
                          :value="'2'"
                          :checked="TMSFlag == '2'"
                          disabled
                          
                        />
                        <span>{{ $t("product.未展示") }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品尺寸：") }}
                  </label>
                  <div class="col-9 d-flex align-items-center">
                    <label
                    class="col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.长") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="productSizeLength"
                    />
                    <span class="pd-x-5">{{ "cm" }}</span>
                  </div>
                     <label
                    class="col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.宽") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="productSizeWidth"
                    />
                    <span class="pd-x-5">{{ "cm" }}</span>
                  </div>
                     <label
                    class="col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.高") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="productSizeHeight"
                    />
                    <span class="pd-x-5">{{ "cm" }}</span>
                  </div>
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.包装尺寸：") }}
                  </label>
                  <div class="col-9 d-flex align-items-center">
                    <label
                    class="col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.长") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="packageSizeLength"
                    />
                    <span class="pd-x-5">{{ "cm" }}</span>
                  </div>
                     <label
                    class="col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.宽") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="packageSizeWidth"
                    />
                    <span class="pd-x-5">{{ "cm" }}</span>
                  </div>
                     <label
                    class="col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.高") }}
                  </label>
                  <div class="col-4 d-flex align-items-center">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model.number="packageSizeHeight"
                    />
                    <span class="pd-x-5">{{ "cm" }}</span>
                  </div>
                  </div>
                </div>

                
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.附加信息：") }}
                  </label>
                  <div class="col-9 d-flex align-items-center">
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="1"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.带电池") }}</span>
                    </label>
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="2"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.侵权") }}</span>
                    </label>
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="3"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.带磁") }}</span>
                    </label>
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="4"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.非液体（化妆品）") }}</span>
                    </label>
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="5"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.液体（化妆品）") }}</span>
                    </label>
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="6"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.液体（非化妆品）") }}</span>
                    </label>
                    <label class="ckbox mg-b-0 mg-r-25">
                      <input
                        type="checkbox"
                        value="7"
                        v-model="spType"
                        :disabled="userinfo.notSupplyChangeInfo == 1"
                      />
                      <span>{{ $t("product.粉末") }}</span>
                    </label>
                  </div>
                </div>

                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品主图：") }}
                  </label>
                  <div class="col-9 d-flex align-items-center">
                    <div
                      class="img-wrap mg-r-15"
                      :class="{ isIll: $isIll(industryImg) }"
                      v-lazy:background-image="industryImg"
                    ></div>
                    <a
                      v-if="userinfo.notSupplyChangeInfo != 1"
                      class="tx-info"
                      href="javascript:;"
                      @click="uploadImg('spu')"
                      >{{ $t("product.上传图片") }}</a
                    >
                    
                    <el-tooltip  v-if="userinfo.notSupplyChangeInfo != 1" class="item" effect="dark" :content="$t('product.主图要求尺寸最小800*800，最大1800*1800，比例要求1：1，白底图！')"  placement="right">
                        <i class="el-icon-info" style="margin-left:5px"></i>
                    </el-tooltip>
                    <input
                      @change="fileChange($event, 's')"
                      type="file"
                      id="addProductImg"
                      style="display: none"
                    />
                  </div>
                </div>

                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品细节图：") }}
                  </label>
                  <div class="col-9 d-flex align-items-center">
                   
                
                    <input
                      @change="fileChange($event, 'm')"
                      type="file"
                      id="addProductImgArr"
                      style="display: none"
                      multiple
                    />
                    <div
                      v-for="(img, imgI) in imageUrlJson"
                      :key="img"
                      class="img-wrap mg-r-15"
                      :class="{ isIll: $isIll(img) }"
                      v-lazy:background-image="img"
                    >
                      <a href="javascript:;" @click="imgDel(imgI)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </a>
                    </div>
                     <a
                      v-if="userinfo.notSupplyChangeInfo != 1"
                      class="mg-r-5 tx-info"
                      href="javascript:;"
                      @click="uploadImg()"
                      >{{ $t("product.上传细节图") }}</a
                    >
                     <el-tooltip  v-if="userinfo.notSupplyChangeInfo != 1" class="item" effect="dark" :content="$t('product.细节图要求最少3张，否则会出现刊登不成功的情况！')" placement="right">
                        <i class="el-icon-info" style="margin-left:5px"></i>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div v-if="changeType != 5" class="form-wrap">
                <h2>{{ $t("product.客户SKU信息") }}</h2>
                <table class="table table-striped tx-12 mg-b-0">
                  <thead>
                    <tr>
                      <td class="valign-middle">
                        {{ $t("product.客户SKU编号") }}
                      </td>
                      <td class="valign-middle">
                        {{ $t("product.合作客户") }}
                      </td>
                      <td class="valign-middle">
                        {{ $t("product.销售价格") }}
                      </td>
                      <td class="valign-middle">
                        <a
                          v-if="!addVirtualSku"
                          class="btn btn-sm btn-success"
                          href="javascript:;"
                          @click="openAddVirtualSku"
                          >{{ $t("product.添加客户SKU编号") }}</a
                        >
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="addVirtualSku">
                      <td>
                        <input
                          style="line-height: 2.1"
                          class="form-control form-control-sm"
                          type="text"
                          id="virtualSkuIpt"
                          :placeholder="$t('product.请输入客户SKU编号')"
                          v-model="addVirtualSkuIpt"
                        />
                      </td>
                      <td>
                        <select-distributor
                          :noLike="true"
                          :key_word="keyDistributorName"
                          @changeKeyword="changeName"
                          @keywordEnter="filtrateName"
                        />
                      </td>
                      <td>
                        <input
                          style="line-height: 2.1"
                          class="form-control form-control-sm"
                          type="text"
                          id="virtualPriceIpt"
                          :placeholder="$t('product.请输入销售价格')"
                          v-model="addVirtualPriceIpt"
                        />
                      </td>
                      <td>
                        <a
                          style="line-height: 2"
                          class="btn btn-sm btn-success"
                          href="javascript:;"
                          @click="saveVirtualSku"
                          >{{ $t("product.保存") }}</a
                        >
                      </td>
                    </tr>
                    <tr v-for="(vSKU, vi) in virtualSkuJson" :key="vSKU.id">
                      <td>{{ vSKU.virtualSku }}</td>
                      <td>{{ vSKU.distributorName }}</td>
                      <td v-if="Number(vSKU.price)">
                        {{ $t("product.￥") }}{{ vSKU.price }}
                      </td>
                      <td v-else>---</td>
                      <td>
                        <a
                          v-if="vSKU.distributorId == 0"
                          class="tx-info"
                          href="javascript:;"
                          @click="delVirtualSku(vSKU, vi)"
                          >{{ $t("product.删除") }}</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="changeType != 5" class="form-wrap">
                <h2>{{ $t("product.原料信息") }}</h2>
                <table class="table table-striped tx-12 mg-b-0">
                  <thead>
                    <tr>
                      <td class="valign-middle">
                        {{ $t("product.原料名称") }}
                      </td>
                      <td class="valign-middle">{{ $t("product.数量") }}</td>
                      <td class="valign-middle">{{ $t("product.单位") }}</td>
                      <td class="valign-middle">{{ $t("product.成本价") }}</td>
                      <td class="valign-middle">{{ $t("product.小计") }}</td>
                      <td class="valign-middle">
                        <a
                          v-if="!addRawSku"
                          class="btn btn-sm btn-success mg-r-15"
                          href="javascript:;"
                          @click="openAddRawSku"
                          >{{ $t("product.添加原料SKU") }}</a
                        >
                        <a
                          v-if="!addRawSku"
                          class="btn btn-sm btn-success"
                          href="javascript:;"
                          @click="showBOM"
                          >{{ $t("rm.BOM图") }}</a
                        >
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="addRawSku">
                      <td class="valign-middle">
                        <el-autocomplete
                          suffix-icon="el-icon-search"
                          size="small"
                          v-model="addRawSkuIpt.name"
                          :fetch-suggestions="querySearchAsync"
                          :placeholder="$t('product.请输入原料名称')"
                          @select="getRawinfo"
                        ></el-autocomplete>
                      </td>
                      <td class="valign-middle">
                        <el-input
                          size="small"
                          v-model="addRawSkuIpt.num"
                          oninput="value=value.replace(/[^0-9]/g,'')"
                          :placeholder="$t('product.请输入数量')"
                        ></el-input>
                      </td>
                      <td class="valign-middle">
                        <select
                          class="form-control form-control-sm"
                          :disabled="Number(addRawSkuIpt.unitType) <= 0"
                          v-model="addRawSkuIpt.unit"
                        >
                          <option value="0">
                            {{ $t("product.请选择单位") }}
                          </option>
                          <option
                            v-for="(value, key) in addRawSkuIpt.unitList"
                            :key="key"
                            :value="key"
                          >
                            {{ value }}
                          </option>
                        </select>
                      </td>
                      <td colspan="3" class="valign-middle">
                        <a
                          class="btn btn-primary btn-sm"
                          href="javascript:;"
                          @click="saveRawSku"
                          >{{ $t("product.添加") }}</a
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(raw, rawI) in rawSkus"
                      :key="raw.id + '_' + rawI"
                    >
                      <td>{{ raw.name }}</td>
                      <td>{{ raw.num }}</td>
                      <td>{{ raw.unitList[raw.unit] }}</td>
                      <td>{{ Number(raw.price).toFixed(2) }}</td>
                      <td>
                        {{ $t("product.￥")
                        }}{{ (Number(raw.price) * Number(raw.num)).toFixed(2) }}
                      </td>
                      <td>
                        <a
                          class="tx-info"
                          href="javascript:;"
                          @click="removeRaw(rawI)"
                          >{{ $t("product.删除") }}</a
                        >
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="rawSkus.length">
                    <tr>
                      <td colspan="3"></td>
                      <td colspan="2">
                        {{ $t("product.合计：") }}{{ $t("product.￥")
                        }}{{ rawTotal }}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="form-wrap">
                <h2>{{ $t("product.备注信息") }}</h2>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.商品备注：") }}
                  </label>
                  <div class="col-9">
                    <textarea
                      rows="3"
                      class="form-control form-control-sm"
                      v-model="productRemark"
                    ></textarea>
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.销售备注：") }}
                  </label>
                  <div class="col-9">
                    <textarea
                      rows="3"
                      class="form-control form-control-sm"
                      v-model="saleRemark"
                    ></textarea>
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.采购备注：") }}
                  </label>
                  <div class="col-9">
                    <textarea
                      rows="3"
                      class="form-control form-control-sm"
                      v-model="purchaseRemark"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="form-wrap">
                <h2>{{ $t("product.产品描述") }}</h2>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.复杂描述：") }}
                  </label>
                  <div class="col-9">
                    <div style="border: 1px solid #ccc;">
                      <Toolbar
                          style="border-bottom: 1px solid #ccc"
                          :editor="editor"
                          :defaultConfig="toolbarConfig"
                          :mode="mode"
                      />
                      <Editor
                          style="height: 500px; overflow-y: hidden;"
                          v-model="html"
                          :defaultConfig="editorConfig"
                          :mode="mode"
                          @onCreated="onCreated"
                      />
                  </div>
                  </div>



                </div>
                
              </div>
              <div class="d-flex justify-content-center">
                <a
                  class="btn btn-primary mg-r-25"
                  href="javascript:;"
                  @click="save"
                  >{{ $t("product.保存") }}</a
                >
                <a
                  class="btn btn-secondary"
                  href="javascrit:;"
                  @click="closeWin"
                  >{{ $t("product.返回") }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <api-loading :show="loading" class="drak"></api-loading>
        <modalEditSkuPrice
          :open="modalEditSkuPriceOpen"
          :info="modalEditSkuPriceInfo"
          :price="modalEditSkuPriceNum"
          @saveSuccess="saveSuccess"
        ></modalEditSkuPrice>
        <!-- 新图片管理 -->
        <ModalUploadProductImages
          :open="openUploadProductImages"
          :imgRule="uploadPImgData.imgRule"
          :sku="uploadPImgData.sku"
          :minSelected="uploadPImgData.min"
          :maxSelected="uploadPImgData.max"
          :loading="uploadPImgData.loading"
          :spuId="uploadPImgData.spuId"
          :spuImages="uploadPImgData.spuImages"
          :stocks="uploadPImgData.stocks"
          :spu="uploadPImgData.spu"
          :type="2"
          @save="uploadProductImgSave"
        />
        <!-- BOM图 -->
        <modalBom :items="bomList" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue"; //$t('product.头')
import Modal from "@components/Modal";
import modalEditSkuPrice from "./modal-edit-price.vue";
import ModalUploadProductImages from "@components/supplier/modal-upload-product-images"; //$t('product.选商品图片')
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索
import modalBom from "@components/modal-bom";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  components: {
    Header,
    Modal,
    modalEditSkuPrice,
    ModalUploadProductImages,
    SelectDistributor,
    modalBom,
    Editor,
    Toolbar,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('product.左边栏$t('product.状态')')
      loading: true,
      id: this.$route.query.id,
      changeType: this.$route.query.changeType
        ? this.$route.query.changeType
        : "",
      skuType: this.$route.query.changeType
        ? this.$route.query.changeType
        : "1",
      info: null,
      name: "",
      propertyValue: "",
      oldSku: "",
      sku: "",
      spu: "",
      price: "",
      salePrice: "",
      factorySku: "",
      totalInventory: "",
      oldStatus: "",
      status: "",
      weight: "",
      categorysArr: [],
      categorys: [],
      categorys1: [],
      categorys2: [],
      category: "",
      category1: "",
      category2: "",
      country: "",
      categoryId1688: "",
      spType: [],
      industryImg: "",
      imageUrlJson: [],
      addVirtualSku: false,
      addVirtualSkuIpt: "",
      addVirtualClientsIpt: "",
      keyDistributorName: "",
      keyDistributorrName: "",
      keyDistributorId: "",
      addVirtualPriceIpt: "",
      virtualSkuJson: [],
      rawSkus: [],
      addRawSku: false,
      addRawSkuIpt: {
        name: "",
        sku: "",
        num: "",
        unitType: "",
        unit: "0",
        unitList: {},
      },
      addRawSkuIptDafeult: "",
      productRemark: "",
      saleRemark: "",
      purchaseRemark: "",
      priceOrder: 0,
      modalEditSkuPriceOpen: Symbol(),
      modalEditSkuPriceInfo: "",
      modalEditSkuPriceNum: "",
      openUploadProductImages: Symbol(),
      uploadPImgData: {
        loading: false,
        imgRule: null,
        sku: "",
        min: 1,
        max: 1,
        spuId: "",
        spu: "",
        spuImages: [],
        stocks: [],
      },
      uploadPImgDataDefault: "{}",
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      restaurants: [],
      rawStockSupplierIds: "",
      bomList: [],

      editor: null,
      html: '',
      TMSFlag: '',
      name_en:'',
      productSizeLength:'',
      productSizeWidth:'',
      productSizeHeight:'',
      packageSizeLength:'',
      packageSizeWidth:'',
      packageSizeHeight:'',
      toolbarConfig: {
          excludeKeys: ['fullScreen', 'insertVideo','group-video'],
       },
      editorConfig: { placeholder: '请输入内容...' },
      mode: 'default', // or 'simple'
      languageConfig: {
        en: true,
        zh: true,
        fra: false,
        spa: false,
        it: false,
        de: false,
        jp: false,
        th: false,
        vn: false,
        id: false,
        ko: false,
        tw: false,
        nl: false,
        pt: false,
        ru: false
      },
    };
  },
  computed: {
    rawTotal() {
      let num = 0;
      if (this.rawSkus.length) {
        this.rawSkus.forEach((raw) => {
          num = num + Number(raw.price) * Number(raw.num);
        });
        return num.toFixed(2);
      } else {
        return "0.00";
      }
    },
  },
  methods: {
    // 原料名称搜索事件
    querySearchAsync(queryString, cb) {
      if (!queryString) return false;
      $.api_call(
        "api.SupplierProductStock.findRawSkuByName",
        {
          name: queryString,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) {
              ShowTip(this.$t("product.搜索不到数据"), "danger");
            }
            this.restaurants = r.Data.Results;
            var results = queryString
              ? this.restaurants.filter(
                  (item) => item.name.indexOf(queryString) > -1
                )
              : this.restaurants;
            results = results.map((item) => {
              item.value = item.name;
              return item;
            });
            cb(results);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    // 获取选中的原料信息对象
    getRawinfo(item) {
      this.addRawSkuIpt.unitType = item.unitType;
      this.addRawSkuIpt.unit = item.unit;
      console.log(item);
      if (Number(item.unitType) > 0) {
        this.getTypeUnits(item.unitType);
      }
    },
    // 获取原料单位类型下所有的单位
    getTypeUnits(type) {
      $.api_call("api.Warehouse.getTypeUnits", { type }, (r) => {
        if (r.ErrorCode == "9999") {
          this.addRawSkuIpt.unitList = r.Data.Results || {};
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    // kano select
    changeName(name, id) {
      this.keyDistributorrName = name;
      this.keyDistributorId = id;
    },
    filtrateName(name, id) {
      if (!id || id == "e999") {
        ShowTip(this.$t("mall.没有匹配的客户"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
      } else {
        //清空按联系人
        this.keyDistributorName = name;
        this.keyDistributorId = id;
      }
    },

    uploadProductImgSave(spuid, spuImages, sku) {
      if (spuid) {
        this.industryImg = spuImages[0];
      } else {
        this.imageUrlJson = spuImages;
      }
      $("#modalUploadProductImages").modal("hide");
    },
    uploadImg(type) {
      this.uploadPImgData = JSON.parse(this.uploadPImgDataDefault);
      this.uploadPImgData.spu = this.info ? this.info.spu : "";
      if (type == "spu") {
        this.uploadPImgData.max = 1;
        this.uploadPImgData.spuId = "spu";
        this.uploadPImgData.spuImages = this.industryImg
          ? [this.industryImg]
          : [];
      } else {
        this.uploadPImgData.max = 100;
        this.uploadPImgData.spuImages = this.imageUrlJson
          ? this.imageUrlJson
          : [];
      }

      this.openUploadProductImages = Symbol();
    },
    save() {
      if (!this.name || !this.sku || !this.category) {
        let message = "";
        if (!this.name) message += this.$t("product.商品名称，");
        if (!this.sku) message += this.$t("product.SKU编号，");
        if (!this.category) message += this.$t("product.商品分类");
        message += this.$t("product.未填写！");
        ShowTip(message, "danger");
        return;
      }
      let relationSkus = [];
      if (this.rawSkus.length > 0) {
        this.rawSkus.forEach((e) => {
          if (Number(e.num) > 0) {
            relationSkus.push({ id: e.id, num: e.num, unit: e.unit });
          }
        });
      }
      let virtualSku = [];
      this.virtualSkuJson.forEach((e) => {
        virtualSku.push(e.virtualSku);
      });
      let params = {
        name: this.name,
        sku: this.oldSku,
        newSku: this.sku,
        status: this.status,
        skuType: this.skuType,
        spu: this.spu,
        country: this.country,
        factorySku: this.factorySku,
        totalInventory: this.totalInventory,
        weight: this.weight,
        categoryId1688:
          this.categorys2.length > 0 ? this.category2 : this.category1,
        virtualSku: virtualSku.join(","),
        spType: this.spType.join(","),
        propertyImage: this.industryImg,
        productRemark: this.productRemark,
        saleRemark: this.saleRemark,
        purchaseRemark: this.purchaseRemark,
        price: this.price,
        salePrice: this.salePrice,
        relationSkus: this.changeType == 5 ? "" : relationSkus,
        imageUrlJson: this.imageUrlJson.join(","),
        propertyValue: this.propertyValue,
        description: this.html,
        name_en: this.name_en,
        productSizeLength: this.productSizeLength,
        productSizeWidth: this.productSizeWidth,
        productSizeHeight: this.productSizeHeight,
        packageSizeLength: this.packageSizeLength,
        packageSizeWidth: this.packageSizeWidth,
        packageSizeHeight: this.packageSizeHeight,
      };
      let apiUrl = "";
      if (this.id) {
        apiUrl =
          this.changeType == 5
            ? "api.SupplierProductStock.changeRawSku"
            : "api.SupplierProductStock.changeBySupplier";
      } else {
        params.sku = this.sku;
        apiUrl =
          this.changeType == 5
            ? "api.SupplierProductStock.addRawSku"
            : "api.SupplierProductStock.addBySupplier";
      }
      let flag = false;
      if (
        this.info &&
        this.changeType == 1 &&
        Number(this.info.price) != Number(this.price)
      ) {
        flag = true;
      }
      this.loading = true;
      $.api_call(apiUrl, params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.保存成功"), "success");
          if (!flag || this.priceOrder == 0) {
            setTimeout(() => {
              this.closeWin();
            }, 1000);
            return;
          }
          if (flag) {
            this.editPrice(this.info, this.price);
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    saveSuccess() {
      ShowTip(this.$t("product.修改选中订单成本价成功"), "success");
      $("#modalEditSkuPrice").modal("hide");
      setTimeout(() => {
        this.closeWin();
      }, 1000);
    },
    editPrice(item, price) {
      this.modalEditSkuPriceOpen = Symbol();
      this.modalEditSkuPriceInfo = item;
      this.modalEditSkuPriceNum = price;
      $("#modalEditSkuPrice").modal("show");
    },
    removeRaw(i) {
      this.rawSkus.splice(i, 1);
    },
    saveRawSku() {
      this.restaurants.forEach((item) => {
        if (item.name == this.addRawSkuIpt.name) {
          this.rawStockSupplierIds = item.id;
          this.stockPriduct = item.price;
        }
      });
      if (!this.addRawSkuIpt.name) {
        ShowTip(this.$t("product.请输入name"), "danger");
        return false;
      }
      if (!this.addRawSkuIpt.num) {
        ShowTip(this.$t("product.请输入数量"), "danger");
        return false;
      }
      if (this.addRawSkuIpt.unitType) {
        if (!this.addRawSkuIpt.unit) {
          ShowTip(this.$t("product.请选择单位"), "danger");
          return false;
        }
      }
      this.rawSkus.push({
        id: this.rawStockSupplierIds,
        name: this.addRawSkuIpt.name,
        price: this.stockPriduct,
        num: this.addRawSkuIpt.num,
        unit: this.addRawSkuIpt.unit,
        unitList: this.addRawSkuIpt.unitList || {},
      });
      this.addRawSku = false;
      this.addRawSkuIpt = JSON.parse(this.addRawSkuIptDafeult);
    },
    openAddRawSku() {
      this.addRawSku = true;
    },
    // 显示BOM图
    showBOM() {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.getBomTree",
        {
          skuId: this.id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            const res = r.Data.Results || {};
            this.bomList = [
              {
                name: res.name,
                sku: res.sku,
                children: res.children,
              },
            ];
            $("#modalBom").modal("show");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    delVirtualSku(item, index) {
      if (item.temp) {
        this.virtualSkuJson.splice(index, 1);
        return;
      }
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.delVirtualSku",
        { id: item.id },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.loading = false;
            this.getData("vsku");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveVirtualSku() {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.checkVirtualSkuExist",
        {
          sku: this.addVirtualSkuIpt,
          distributorId: this.keyDistributorId,
          price: this.addVirtualPriceIpt,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (!this.id) {
              this.virtualSkuJson.unshift({
                distributorId: this.keyDistributorId,
                id: new Date().valueOf(),
                distributorName: this.keyDistributorName,
                price: this.addVirtualPriceIpt,
                sku: this.sku,
                sold30Days: 0,
                sold7Days: 0,
                virtualSku: this.addVirtualSkuIpt,
                temp: true,
              });
              this.addVirtualSku = false;
              this.addVirtualSkuIpt = "";
              let hash = {};
              this.virtualSkuJson = this.virtualSkuJson.reduce((item, next) => {
                hash[next.virtualSku]
                  ? ""
                  : (hash[next.virtualSku] = true && item.push(next));
                return item;
              }, []);
              return;
            }
            if (!this.sku) {
              ShowTip(this.$t("product.请先填写SKU"), "danger");
              return;
            }
            this.loading = true;
            $.api_call(
              "api.SupplierProductStock.addVirtualSku",
              {
                sku: this.sku,
                virtualSku: this.addVirtualSkuIpt,
                distributorId: this.keyDistributorId,
                price: this.addVirtualPriceIpt,
              },
              (r) => {
                this.loading = false;
                if (r.ErrorCode == "9999") {
                  this.getData("vsku");
                  this.addVirtualSku = false;
                  this.addVirtualSkuIpt = "";
                } else {
                  if (r.ErrorCode == "1002") {
                    userFailure(this);
                  } else {
                    ShowTip(r.Message, "danger");
                  }
                }
              }
            );
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openAddVirtualSku() {
      this.addVirtualSku = true;
      $("#virtualSkuIpt").focus();
    },
    getCategorys() {
      this.loading = true;
      $.getJSON("./categorys.json", (r) => {
        this.loading = false;
        this.categorys = r;
        this.categorys1 = [];
        this.categorys2 = [];
        this.category = "";
        this.category1 = "";
        this.category2 = "";
        if (this.info && this.info.categoryPathId.length > 0) {
          this.category = this.info.categoryPathId[0];
          this.selectCategory();
          this.category1 = this.info.categoryPathId[1];
          this.selectCategory1();
          if (this.info.categoryPathId.length > 2) {
            this.category2 = this.info.categoryPathId[2];
          }
        }
        if (this.id || this.$route.query.copyId) {
          // 商品名称
          this.name = this.info.name;
          //sku
          if (!this.$route.query.copyId) {
            this.oldSku = this.sku = this.info.sku;
          }
          //spu
          this.spu = this.info.spu;
          // 成本价
          this.price = this.info.price;
          // 原厂SKU
          this.factorySku = this.info.factorySku;
          //库存数量
          this.totalInventory = this.info.totalInventory;
          // 状态
          this.oldStatus = this.info.status;
          this.status = this.info.status;
          // 重量
          this.weight = this.info.weight;
          //附近信息
          this.pType = this.info.pType;
          // 主图
          this.industryImg = this.info.propertyImage;
          // 细节图
          this.imageUrlJson = this.info.imageUrlJson
            ? this.info.imageUrlJson.split(",")
            : [];
          // 客户sku信息
          if (!this.$route.query.copyId) {
            this.virtualSkuJson = this.info.virtualSku;
          }
          // 原料商品
          let arr = this.info.relationRaws || [];
          arr.forEach((ele) => {
            this.rawSkus.push({
              id: ele.rawSkuId,
              num: ele.num,
              price: ele.price,
              name: ele.name,
              sku: ele.sku,
              unit: ele.unit,
              unitList: ele.units || {},
            });
          });
          // 附加信息
          this.spType = this.info.spType;
          this.productRemark = this.info.productRemark;
          this.saleRemark = this.info.saleRemark;
          this.purchaseRemark = this.info.purchaseRemark;
          // 属性
          this.propertyValue = this.info.propertyValue;
          // 销售价格
          this.salePrice = this.info.salePrice;
        }
      });
    },
    getDataOrder() {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.getOrders",
        {
          sku: this.info.sku,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.priceOrder = r.Data.Results.length;
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    getData(type) {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.findBySupplier",
        { id: this.$route.query.copyId ? this.$route.query.copyId : this.id },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (type == "vsku") {
              this.virtualSkuJson = r.Data.Results[0].virtualSku;
            } else {
              this.info = r.Data.Results[0];
              this.priceOrder = 0;
              this.html = r.Data.Results[0].description || '';
              this.country = r.Data.Results[0].country || '';
              this.TMSFlag = r.Data.Results[0].TMSFlag || '';
              this.name_en = r.Data.Results[0].nameEn || '';
              this.productSizeLength = r.Data.Results[0].productSizeLength || 0;
              this.productSizeWidth= r.Data.Results[0].productSizeWidth || 0;
              this.productSizeHeight=r.Data.Results[0].productSizeHeight || 0;
              this.packageSizeLength= r.Data.Results[0].packageSizeLength || 0;
              this.packageSizeWidth=r.Data.Results[0].packageSizeWidth || 0;
              this.packageSizeHeight=r.Data.Results[0].packageSizeHeight || 0;
              console.log(this.TMSFlag)
              if (this.info && this.info.sku) {
                this.getDataOrder();
              }
              this.getCategorys();
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    fileClick(type) {
      // 触发上传
      if (type == "s") {
        document.getElementById("addProductImg").click();
      } else {
        document.getElementById("addProductImgArr").click();
      }
    },
    fileChange(el, type) {
      if (!el.target.files[0].size) return;
      this.fileList(el.target, type);
      el.target.value = "";
    },
    fileList(fileList, type) {
      // 文件上传控件处理
      let files = fileList.files;
      if (type == "m" && files.length + this.imageUrlJson.length > 9) {
        // 已经大于9张
        ShowTip(this.$t("product.最多上传9张图片"), "danger");
        return;
      }
      for (let i = 0; i < files.length; i++) {
        // 判断是否为文件夹
        if (files[i].type != "") {
          this.fileAdd(files[i], type);
        }
      }
    },
    // 处理文件
    fileAdd(file, type) {
      // 判断是否为图片文件
      if (type == "m" && this.imageUrlJson.length > 8) {
        // 已经大于9张
        ShowTip(this.$t("product.最多上传9张图片"), "danger");
        return;
      }
      if (file.type.indexOf("image") == -1) {
        return;
      } else {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.uploadCostReduceBase64(e.target.result, type);
        };
      }
    },
    uploadCostReduceBase64(file, type) {
      this.loading = true;
      let image = new Image();
      image.src = file;
      image.onload = () => {
        let width = image.width;
        let height = image.height;
        if (width < 100 || height < 100) {
          this.loading = false;
          ShowTip(this.$t("product.图片的宽或者高都不能小于100px"), "danger");
          return;
        }
        $.api_call(
          "api.CostReduce.uploadImage",
          {
            imageBase64: file.split("base64,").pop().replace(/\r\n/g, ""),
            imageBase64Suffix: "jpg",
          },
          (r) => {
            this.loading = false;
            if (r.ErrorCode == "9999") {
              if (type == "s") {
                this.industryImg = r.Data.Results;
              } else {
                this.imageUrlJson.push(r.Data.Results);
              }
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      };
    },
    imgDel(i) {
      this.imageUrlJson.splice(i, 1);
    },
    selectCategory() {
      this.category1 = "";
      this.category2 = "";
      this.categorys1 = [];
      this.categorys2 = [];
      let p = this.category;
      this.categorys.forEach((e) => {
        if (p == e.categoryId1688) {
          if (e.children) {
            this.categorys1 = e.children;
          }
        }
      });
    },
    selectCategory1() {
      this.category2 = "";
      this.categorys2 = [];
      let c = this.category1;
      if (!c) return;
      this.categorys1.forEach((e) => {
        if (c == e.categoryId1688) {
          if (e.children) {
            this.categorys2 = e.children;
          }
        }
      });
    },
    closeWin() {
      this.$router.push({ path: "/storage-pro/" });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },

    //英文缩写对应的语言名称
    getLanguageName(abbr) {
      let name = null
      switch (abbr) {
        case 'zh':
          name = this.$t('中文')
          break
        case 'en':
          name = this.$t('英文')
          break
        case 'fra':
          name = this.$t('法语')
          break
        case 'spa':
          name = this.$t('西班牙语')
          break
        case 'it':
          name = this.$t('意大利语')
          break
        case 'de':
          name = this.$t('德语')
          break
        case 'jp':
          name = this.$t('日语')
          break
        case 'th':
          name = this.$t('泰语')
          break
        case 'vn':
          name = this.$t('越南语')
          break
        case 'id':
          name = this.$t('印尼语')
          break
        case 'ko':
          name = this.$t('韩语')
          break
        case 'tw':
          name = this.$t('中文繁体')
          break
        case 'nl':
          name = this.$t('荷兰语')
          break
        case 'pt':
          name = this.$t('葡萄牙语')
          break
        case 'ru':
          name = this.$t('俄语')
          break
      }
      return name
    },
  },
  mounted() {
    this.addRawSkuIptDafeult = JSON.stringify(this.addRawSkuIpt);
    this.uploadPImgDataDefault = JSON.stringify(this.uploadPImgData);
    if (this.id || this.$route.query.copyId) {
      this.getData();
    } else {
      this.getCategorys();
    }
    // setTimeout(() => {
    //         this.html = ''
    //     }, 1500)
  },
  beforeDestroy() {
        const editor = this.editor
        this.html = ''
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
};
</script>

<style lang="less" scoped>
.collapsed-menu .br-contentpanel {
  margin-left: 60px;
}
.form-wrap {
  position: relative;
  border: 1px #ddd solid;
  margin-bottom: 25px;
  padding: 25px;
  > h2 {
    position: absolute;
    top: -16px;
    left: 15px;
    z-index: 0;
    padding: 0 10px;
    background: #fff;
    line-height: 32px;
    font-weight: 700;
    font-size: 16px;
  }
}
.img-wrap {
  position: relative;
  width: 80px;
  height: 80px;
  background-size: cover;
  background-position: center;
  border: 1px #ddd solid;
  > a {
    position: absolute;
    right: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: #dc3545;
    color: #fff;
    font-size: 12px;
  }
  > a:hover {
    background-color: #c82333;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>